const Airtable = require('airtable')

exports.onClientEntry = () => {
  Airtable.configure({ apiKey: process.env.GATSBY_AIRTABLE_API_KEY })
}
